




























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import shopCart from "@/store/modules/shopCart";
import ItemModel from "@/store/models/ItemModel";

@Component({ components: { Modal } })
export default class AddToCartModal extends Vue {
  @Prop() handleModal!: Function;
  @Prop() item!: ItemModel;
  @Prop() isModalOpen!: boolean;
  quantity = 1;

  get lowQuantity() {
    return this.quantity <= 1 ? true : false;
  }

  handleAddItemToCart() {
    if (this.quantity > 0)
      shopCart.addItem({ item: this.item, quantity: this.quantity });
    this.handleModal();
  }

  @Watch("isModalOpen")
  clearQuantity() {
    this.quantity = 1;
  }
}
